import { Alert, bodySmallStyles, labelDefaultMediumStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
`

export const Description = styled.p`
  ${bodySmallStyles};
  color: ${({ theme }) => theme.color.content.main};
  margin: 0;
`

export const AutomationsSection = styled.div`
  background: ${({ theme }) => theme.color.background.main};
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['05']};
  padding: ${({ theme }) => theme.size.space['05']};
`

export const AutomationsSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['02']};
`

export const AutomationsSectionTitle = styled.p`
  ${labelDefaultMediumStyles};
  color: ${({ theme }) => theme.color.content.main};
  margin: 0;
`

export const AutomationsSectionDescription = styled.p`
  ${bodySmallStyles};
  color: ${({ theme }) => theme.color.content.main};
  margin: 0;
`

export const ImmutableWarning = styled.p`
  ${bodySmallStyles};
  color: ${({ theme }) => theme.color.content.secondary};
  margin: 0;
`

export const EvaluationAlert = styled(Alert)`
  margin: 0;
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`
